import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { EmployeeFormComponent } from './employee-form/employee-form.component';
import { DetailEmployeeComponent } from './detail-employee/detail-employee.component';
import { ListEmployeeComponent } from './list-employee/list-employee.component';
import { DateUtils } from 'src/app/shared/utils/date-utils';
import { GestionDonneesModule } from '../gestion-donnees/gestion-donnees.module';
import { EmployeeModalAjoutComponent } from './modal/employee-modal-ajout/employee-modal-ajout.component';
import { AvailabilityEmployeeComponent } from './availability-employee/availability-employee.component';

@NgModule({
	declarations: [
		EmployeeFormComponent,
		DetailEmployeeComponent,
		ListEmployeeComponent,
		EmployeeModalAjoutComponent,
		AvailabilityEmployeeComponent
	],
	imports: [SharedModule, GestionDonneesModule],
	providers: [DateUtils]
})
export class EmployeesModule {}
